const partTypes = [
  "None",
  "Resistor",
  "Capacitor",
  "Inductor",
  "Diode",
  "LED",
  "Transistor",
  "Crystal",
  "Oscillator",
  "Relay",
  "Switch",
  "Wire",
  "Potentiometer",
  "Fuse",
  "Circuit Breaker",
  "Connector",
  "Cable",
  "Solder",
  "Soldering Iron",
  "Breadboard",
  "Protoboard",
  "Multimeter",
  "Oscilloscope",
  "Battery",
  "Heat Sink",
  "Fan",
  "IC (Integrated Circuit)",
  "Transformer",
  "Rotary Encoder",
  "Buzzer/Speaker",
  "USB Camera",
];

export default partTypes;
